/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import ListGroup from 'react-bootstrap/ListGroup';
import Grid from '../../atoms/Grid/Grid';
import Sidebar from '../../molecules/Sidebar/Sidebar';
import FullPageLoader from '../../atoms/FullPageLoader/FullPageLoader';
import BuildingGridItem from '../../molecules/BuildingGridItem/BuildingGridItem';
import Icon from '../../atoms/Icon/Icon';
import Api from '../../../services/Api';
import { setSelectedBuildingAction } from '../../../actions/instances/buildings';
import './HomePage.scss';

const HomePage = () => {
  const {
    mainFilters,
    isLoadingMainBuildings,
    filteredBuildings,
  } = useSelector(state => state.buildings);
  const [buildings, setBuildings] = useState([]);
  const history = useHistory();
  const dispatch = useDispatch();
  useEffect(() => {
    Api.get('instances/buildings').then((response) => {
      if (response.status === 200) {
        setBuildings(response.data.data);
      }
    });
  }, []);
  const { dynastiesList, isLoadingDynasties } = useSelector(state => state.dynasties);
  const { isLoadingCountries, countriesList } = useSelector(state => state.countries);
  if (isLoadingMainBuildings) {
    return <FullPageLoader />;
  }
  if (mainFilters.length > 0) {
    return (
      <Grid>
        {filteredBuildings.map(building => (
          <div className="col-md-3 p-2">
            <BuildingGridItem building={building} />
          </div>
        ))}
      </Grid>
    );
  }
  return (
    <div className="row">
      <div className="col-md-1" />
      <div className="col-md-8 page-content">
        <div className="row separator">
          <section className="col-md-4 articles-list">
            {isLoadingCountries ? (
              <FullPageLoader />
            ) : (
              <>
                <h5>Locations</h5>
                <ListGroup variant="flush">
                  {countriesList.slice(0, 5).map(country => (
                    <ListGroup.Item
                      as="li"
                      className="d-flex justify-content-between align-items-start p-3"
                      key={`country-${country.code}`}
                    >
                      <div className="ms-2 me-auto">
                        <div>
                          <span>
                            <Icon icon="edit" color="#aaa" />
                          </span>
                          {/* eslint-disable-next-line jsx-a11y/anchor-is-valid,no-script-url */}
                          <a onClick={() => history.push('/countries')} href="javascript:void(0)">
                            <span className="ms-2">{`${country.name} [${country.code}]`}</span>
                          </a>
                        </div>
                      </div>
                    </ListGroup.Item>
                  ))}
                </ListGroup>
              </>
            )}
          </section>
          <section className="col-md-4">
            {isLoadingDynasties ? (
              <FullPageLoader />
            ) : (
              <>
                <h5>Dynasties</h5>
                <ListGroup variant="flush">
                  {dynastiesList.slice(0, 5).map(dynasty => (
                    <ListGroup.Item
                      as="li"
                      className="d-flex justify-content-between align-items-start p-3"
                      key={`dynasty-${dynasty.code}`}
                    >
                      <div className="ms-2 me-auto">
                        <div>
                          <span className="me-2">
                            <Icon icon="edit" color="#aaa" />
                          </span>
                          {/* eslint-disable-next-line jsx-a11y/anchor-is-valid,no-script-url */}
                          <a onClick={() => history.push('/dynasties')} href="javascript:void(0)">
                            <span className="ml-2">{`${dynasty.name} [${dynasty.code}]`}</span>
                          </a>
                        </div>
                      </div>
                    </ListGroup.Item>
                  ))}
                </ListGroup>
              </>
            )}
          </section>
          <section className="col-md-4">
            {isLoadingDynasties ? (
              <FullPageLoader />
            ) : (
              <>
                <h5>Buildings</h5>
                <ListGroup variant="flush">
                  {buildings.slice(0, 5).map(building => (
                    <ListGroup.Item
                      as="li"
                      className="d-flex justify-content-between align-items-start p-3"
                      key={`dynasty-${building.id}`}
                    >
                      <div className="ms-2 me-auto">
                        <div>
                          <span className="me-2">
                            <Icon icon="edit" color="#aaa" />
                          </span>
                          <a
                            href="javascript:void(0)"
                            onClick={() => {
                              dispatch(setSelectedBuildingAction(building));
                              history.push('/buildings/view');
                            }}
                          >
                            <span className="ml-2">{`${building.name} [#${building.number}]`}</span>
                          </a>
                        </div>
                      </div>
                    </ListGroup.Item>
                  ))}
                </ListGroup>
              </>
            )}
          </section>
        </div>
      </div>
      <div className="col-md-3">
        <Sidebar />
      </div>
    </div>
  );
};

export default HomePage;
